export default class DialogPassengerAgeItem {
  constructor(_parent,_index,_defaultVal = '') {
    this.index = _index;

    this.target = document.createElement('div');
    this.target.classList.add('-select');
    let html = `
      <select name="chdage">
          <option value="-">-</option>
          `;
    for(let i=0;i<=17;i++) html += `<option value="${i}">${i}</option>`;
    html += `
      </select>
    `;
    this.target.innerHTML = html;

    _parent.appendChild(this.target);

    this.select = this.target.querySelector('select');

    if (this.select.querySelector(`option[value="${_defaultVal}"]`)) {
      this.select.value = _defaultVal;
    } else {
      this.select.selectedIndex = 0;
    }
  }

  onDelete(){
    this.select = null;
    this.target.remove();
    this.target = null;
  }
}
